<template lang="html">
  <div id="Map">
    <!-- GPS -->
    <div class="floating-ui gm-shadow map-button ">
      <el-button icon="el-icon-aim" @click="getLocation" :type="isFollowing? 'warning': ''" style="border: none;"></el-button>
    </div>
    <!-- selectedKMarker -->
    <div :class="{'mobile': $store.state.isMobile, 'web': !$store.state.isMobile, 'floating-ui': true, 'gm-shadow': true, 'selected-marker-info': true, 'single-marker': true}" v-if="selectedKMarker !== null" @click.self="onKMarkerClick(kMarkers[selectedKMarker.teamIndex][selectedKMarker.markerIndex].markerInfo)">
      <div class="gm-layout-vertical" @click.self="onKMarkerClick(kMarkers[selectedKMarker.teamIndex][selectedKMarker.markerIndex].markerInfo)">
        <div class="selected-marker-title" @click.self="onKMarkerClick(kMarkers[selectedKMarker.teamIndex][selectedKMarker.markerIndex].markerInfo)">
          {{ selectedKMarker.name + ' / ' + (selectedKMarker.teamIndex + 1) + '팀' }}
        </div>
        <div class="selected-marker-address" @click.self="onKMarkerClick(kMarkers[selectedKMarker.teamIndex][selectedKMarker.markerIndex].markerInfo)">
          {{ selectedKMarker.address }}
        </div>
        <div class="selected-marker-phone">
          <a :href="'tel:' + selectedKMarker.phone">
            {{ selectedKMarker.phone }}
          </a>
        </div>
      </div>
      <div style="margin: auto 0 auto auto;" @click.self="onKMarkerClick(kMarkers[selectedKMarker.teamIndex][selectedKMarker.markerIndex].markerInfo)">
        <vs-switch color="success" v-model="markerState[selectedKMarker.teamIndex][selectedKMarker.markerIndex]" @input="changeState(selectedKMarker.teamIndex, selectedKMarker.markerIndex)" style="width: 48px;">
          <span slot="on">완료</span>
          <span slot="off"></span>
        </vs-switch>
      </div>
    </div>
    <!-- selectedKMarkers (click cluster) -->
    <div :class="{'mobile': $store.state.isMobile, 'web': !$store.state.isMobile, 'floating-ui': true, 'gm-shadow': true, 'selected-marker-info': true}" v-if="selectedKMarkers !== null">
      <div id="cluster-info-wrapper" ref="clusterInfoWrapper">
        <div :class="{'cluster-markerinfo': true, 'no-phone': !selectedKMarkers[0].markerInfo.marker.hasOwnProperty('phone')}" v-for="(kMarker, i) in selectedKMarkers" :key="i" @click.self="onKMarkerClick(kMarker.markerInfo)">
          <div class="gm-layout-vertical" @click.self="onKMarkerClick(kMarker.markerInfo)">
            <div class="selected-marker-title" @click.self="onKMarkerClick(kMarker.markerInfo)">
              {{ kMarker.markerInfo.marker.name + ' / ' + (kMarker.markerInfo.teamIndex + 1) + '팀' }}
            </div>
            <div class="selected-marker-address" @click.self="onKMarkerClick(kMarker.markerInfo)">
              {{ kMarker.markerInfo.marker.address }}
            </div>
            <div class="selected-marker-phone">
              <a :href="'tel:' + kMarker.markerInfo.marker.phone">
                {{ kMarker.markerInfo.marker.phone }}
              </a>
            </div>
          </div>
          <div style="margin: auto 0 auto auto;" @click.self="onKMarkerClick(kMarker.markerInfo)">
            <vs-switch color="success" v-model="markerState[kMarker.markerInfo.teamIndex][kMarker.markerInfo.markerIndex]" @input="changeState(kMarker.markerInfo.teamIndex, kMarker.markerInfo.markerIndex)" style="width: 48px;">
              <span slot="on">완료</span>
              <span slot="off"></span>
            </vs-switch>
          </div>
        </div>
      </div>
    </div>
    <KakaoMap class="map" />
  </div>
</template>
<script>
import KakaoMap from '@/components/Project/KakaoMap/kakaoMap.vue'

export default {
  name: 'MapContainer',
  components: {
    KakaoMap
  },
  props: {
    changeState: Function
  },
  data: () => ({
    map: null,
    mapData: null,
    markerState: null,
    myLocationMarker: null,
    kMarkers: [],
    markerIcons: null,
    selectedTeamIndex: -1,
    selectedKMarker: null,
    markerClusterer: null,
    markerImages: {
      me: 'https://firebasestorage.googleapis.com/v0/b/gentle-map.appspot.com/o/static%2Fmy-location.png?alt=media&token=126148ca-77b3-4579-8ece-07b110902de2',
      done: 'https://firebasestorage.googleapis.com/v0/b/gentle-map.appspot.com/o/static%2Fmarker-done.png?alt=media&token=48791d4e-79da-486e-a709-bc397fd7ff48',
      yet: 'https://firebasestorage.googleapis.com/v0/b/gentle-map.appspot.com/o/static%2Fmarker-yet.png?alt=media&token=4a244e91-db72-43e8-b024-856ffbafe408'
    },
    markerImageSize: {
      width: 18.5,
      height: 30
    },
    isFollowing: false,
    geoLocationWatchId: null,
    clusterer: null,
    selectedKMarkers: null,
    selectScale: 1.2
  }),
  mounted() {
    // Register the events listener
    this.getMapLoadedEvent()
    this.getMapDataLoadedEvent()
    this.getMarkerStateLoadedEvent()
    this.getMarkerSelectedEvent()
    this.getSelectedTeamIndexEvent()
    this.getShowSidebarEvent()
  },
  beforeDestroy() {
    this.$event.$off([
      this.$eventList.showSidebar,
      this.$eventList.mapLoaded,
      this.$eventList.markerStateLoaded,
      this.$eventList.mapDataLoaded,
      this.$eventList.markerSelected,
      this.$eventList.selectedTeamIndex
    ])
    if (this.geoLocationWatchId !== null) {
      navigator.geolocation.clearWatch(this.geoLocationWatchId)
    }
  },
  methods: {
    getShowSidebarEvent() {
      // After resizing sidebar, relayout the map
      this.$event.$on(this.$eventList.showSidebar, isShow => {
        setTimeout(_ => {
          const center = this.map.getCenter()
          this.map.relayout()
          this.map.panTo(center)
        }, 600)
      })
    },
    // 마커 클러스터러를 로드
    loadClusterer() {
      this.clusterer = new kakao.maps.MarkerClusterer({
        map: this.map, // 마커들을 클러스터로 관리하고 표시할 지도 객체
        averageCenter: true, // 클러스터에 포함된 마커들의 평균 위치를 클러스터 마커 위치로 설정
        minLevel: 1, // 클러스터 할 최소 지도 레벨
        disableClickZoom: true, // 클러스터 마커를 클릭했을 때 지도가 확대되지 않도록 설정
        calculator: [10, 30, 50],
        styles: [{ // calculator 각 사이 값 마다 적용될 스타일을 지정한다
            width: '40px',
            height: '40px',
            background: 'rgba(128, 160, 241, .9)',
            borderRadius: '20px',
            color: '#FFF',
            textAlign: 'center',
            fontWeight: 'bold',
            lineHeight: '41px'
          },
          {
            width: '45px',
            height: '45px',
            background: 'rgba(245, 108, 108, .9)',
            borderRadius: '22.5px',
            color: '#FFF',
            textAlign: 'center',
            fontWeight: 'bold',
            lineHeight: '46px'
          },
          {
            width: '50px',
            height: '50px',
            background: 'rgba(128, 210, 209, .9)',
            borderRadius: '25px',
            color: '#FFF',
            textAlign: 'center',
            fontWeight: 'bold',
            lineHeight: '51px'
          }
        ]
      })
      // 마커 클러스터러에 클릭이벤트를 등록
      // 마커 클러스터러를 생성할 때 disableClickZoom을 true로 설정하지 않은 경우
      // 이벤트 헨들러로 cluster 객체가 넘어오지 않을 수도 있음
      kakao.maps.event.addListener(this.clusterer, 'clusterclick', (cluster) => {
        this.onClustererClick(cluster)
      })
    },
    // 맵 로드 완료시 호출
    getMapLoadedEvent() {
      this.$event.$on(this.$eventList.mapLoaded, map => {
        this.$log.d('map loaded', map)
        this.map = map

        // Load clusterer
        this.loadClusterer()

        // 지도가 확대 또는 축소되면 마지막 파라미터로 넘어온 함수를 호출하도록 이벤트를 등록
        kakao.maps.event.addListener(this.map, 'zoom_changed', () => {
          // 선택한 마커 클러스터 초기화
          if (this.selectedKMarkers !== null) {
            this.selectedKMarkers = null
          }
        })

        // 지도 클릭 리스너
        kakao.maps.event.addListener(map, 'click', mouseEvent => {
          // 기존에 선택된 마커 이미지 초기화
          if (this.selectedKMarker !== null) {
            const unselectedMarker = this.selectedKMarker
            this.drawUnselectedMarker(unselectedMarker)
            this.selectedKMarker = null
          }
          // 선택한 마커 클러스터 초기화
          if (this.selectedKMarkers !== null) {
            this.selectedKMarkers = null
          }
        })
      })
    },
    // GPS
    getLocation() {
      if (navigator.geolocation) {
        this.isFollowing = !this.isFollowing
        this.$log.d('geolocation supported')
        if (this.geoLocationWatchId === null) {
          this.geoLocationWatchId = navigator.geolocation.watchPosition(position => {
            this.$log.d('watch position', position)
            const lat = position.coords.latitude
            const lng = position.coords.longitude

            // 내 위치 표시
            if (this.myLocationMarker !== null) {
              this.myLocationMarker.setPosition(new kakao.maps.LatLng(lat, lng))
              // this.myLocationMarker.setMap(this.map)
            } else {
              const markerImage = this.createMyLocationImage()
              const marker = this.createMarker(lat, lng, markerImage)
              marker.setMap(this.map)
              this.myLocationMarker = marker
            }

            if (this.isFollowing) {
              this.moveMapCenter(lat, lng)
            }
          }, err => {
            this.$log.w('watch position error', err)
          }, {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 3000
          })
        }
        // navigator.geolocation.getCurrentPosition(position => {
        //   this.$log.d('position', position)
        //   const lat = position.coords.latitude
        //   const lng = position.coords.longitude

        //   // 내 위치 표시
        //   const markerImage = this.createMyLocationImage()
        //   const marker = this.createMarker(lat, lng, markerImage)
        //   if (this.myLocationMarker !== null) this.myLocationMarker.setMap(null)
        //   marker.setMap(this.map)
        //   this.myLocationMarker = marker

        //   // 내 위치로 지도 이동
        //   this.moveMapCenter(lat, lng)
        // }, err => {
        //   this.$log.w(err)
        // }, {
        //   enableHighAccuracy: true,
        //   timeout: 10000,
        //   maximumAge: 3000
        // })
      } else {
        this.$log.w('Geolocation is not supported by this browser.')
        this.$vs.notify({
          title: 'GPS 미지원 브라우저!',
          text: 'GPS가 지원되지 않는 브라우저에요 😭',
          color: 'warning',
          position: 'top-center'
        })
      }
    },
    // 마커상태 변경 또는 로드시 호출 (맵 데이터가 로드 된 뒤 호출)
    getMarkerStateLoadedEvent() {
      this.$event.$on(this.$eventList.markerStateLoaded, state => {
        this.$log.d('get markerStateLoaded event :', state)
        let isInitiate = false
        for (let i = 0; i < state.length; i++) {
          const numOfMarkers = Object.keys(state[i]).length
          if (this.kMarkers.length < state.length) {
            this.kMarkers[i] = []
          }
          for (let j = 0; j < numOfMarkers; j++) {
            const isDone = state[i][j]
            if (this.markerState === null) {
              // 첫 로드시
              isInitiate = true
              const markerImage = this.createMarkerImage(isDone)
              this.createKMarker(isDone, markerImage, i, j)
            } else {
              const kMarker = this.kMarkers[i][j]
              if (kMarker.isDone !== isDone) {
                // 상태가 변한 경우
                let markerImage = null
                if (this.selectedKMarker === null || kMarker.markerInfo.marker.address !== this.selectedKMarker.address) {
                  // 선택하지 않은 마커가 변한 경우
                  markerImage = this.createMarkerImage(isDone)
                } else {
                  // 선택한 마커가 변한 경우
                  markerImage = this.createSelectedMarkerImage(isDone)
                }
                kMarker.isDone = isDone
                kMarker.setImage(markerImage)
              }
            }
          }
        }

        this.markerState = state
        if (isInitiate) {
          // 첫 로드시
          this.$log.d('first getMarkerStateLoaded', this.kMarkers)
          // 마커의 중심으로 이동
          this.$event.$emit(this.$eventList.selectedTeamIndex, -1)
          // 클러스터러에 마커 추가
          for (let teamIndex in this.kMarkers) {
            this.clusterer.addMarkers(this.kMarkers[teamIndex])
          }
        }
      })
    },
    // 마커 클릭 리스너
    onKMarkerClick(markerInfo, zoom = true) {
      // 선택한 마커 클러스터 초기화
      if (this.selectedKMarkers !== null) {
        this.selectedKMarkers = null
      }
      // 기존에 선택된 마커 이미지 초기화
      if (this.selectedKMarker !== null) {
        const unselectedMarker = this.selectedKMarker
        this.drawUnselectedMarker(unselectedMarker)
      }

      this.selectedKMarker = markerInfo.marker
      this.selectedKMarker['teamIndex'] = markerInfo.teamIndex
      this.selectedKMarker['markerIndex'] = markerInfo.markerIndex
      this.selectedKMarker['isDone'] = this.markerState[markerInfo.teamIndex][markerInfo.markerIndex]

      // 지도에서 마커 선택시 빼고 해당 마커 확대
      if (zoom) {
        const lat = markerInfo.marker.y
        const lng = markerInfo.marker.x
        this.setMapLevel(lat, lng, 3)
      }

      // 현재 선택된 마커 이미지 확대
      this.drawSelectedMarker(this.selectedKMarker)

      // 마커로 화면이동
      this.moveMapCenter(markerInfo.marker.y, markerInfo.marker.x)
    },
    // 클러스터 클릭 리스너
    onClustererClick(cluster) {
      // 현재 지도 레벨에서 1레벨 확대한 레벨
      // 지도를 클릭된 클러스터의 마커의 위치를 기준으로 확대
      // let level = this.map.getLevel() - 1
      // if (level > 5) {
      //   level = 5
      //   this.map.setLevel(level, { anchor: cluster.getCenter() })
      // }

      // Scroll 위치 초기화
      this.$nextTick(() => {
        if (this.$refs.clusterInfoWrapper !== undefined) {
          this.$refs.clusterInfoWrapper.scrollTop = 0
        }
      })

      // 기존에 선택된 마커 이미지 초기화
      if (this.selectedKMarker !== null) {
        const unselectedMarker = this.selectedKMarker
        this.drawUnselectedMarker(unselectedMarker)
        this.selectedKMarker = null
      }
      this.selectedKMarkers = cluster.getMarkers()
    },
    // 마커 생성
    createKMarker(isDone, markerImage, teamIndex, markerIndex) {
      // const isDone = markerState[teamIndex][markerIndex]
      const marker = this.mapData[teamIndex][markerIndex]
      const markerInfo = {
        marker: marker,
        teamIndex: teamIndex,
        markerIndex: markerIndex
      }

      // const markerImage = this.createMarkerImage(isDone)
      let kMarker = this.createMarker(marker.y, marker.x, markerImage)
      kMarker.isDone = JSON.parse(JSON.stringify(isDone))
      kMarker.markerInfo = JSON.parse(JSON.stringify(markerInfo))

      // Click listener
      kakao.maps.event.addListener(kMarker, 'click', _ => {
        this.$log.d('click kMarker', kMarker)
        this.onKMarkerClick(kMarker.markerInfo, false)
      })

      // Mouse over listener
      kakao.maps.event.addListener(kMarker, 'mouseover', _ => {
        this.$log.d('mouse over kMarker', kMarker)
        this.drawSelectedMarker(kMarker.markerInfo)
      })

      // Mouse out listener
      kakao.maps.event.addListener(kMarker, 'mouseout', _ => {
        this.$log.d('mouse out kMarker', kMarker)
        if (this.selectedKMarker === null || kMarker.markerInfo.marker.address !== this.selectedKMarker.address) {
          this.drawUnselectedMarker(kMarker.markerInfo)
        }
      })

      this.kMarkers[teamIndex][markerIndex] = kMarker

      // 지도에 마커 추가
      kMarker.setMap(this.map)
    },
    // 마커 데이터 로드시 호출
    getMapDataLoadedEvent() {
      // Emmit from NavBar selectedTeam() in computed
      this.$event.$on(this.$eventList.mapDataLoaded, mapData => {
        this.$log.d('get mapDataLoaded event :', mapData)
        this.mapData = mapData.team
      })
    },
    // Sidebar에서 해당 마커정보를 선택시 호출
    getMarkerSelectedEvent() {
      this.$event.$on(this.$eventList.markerSelected, markerInfo => {
        this.onKMarkerClick(markerInfo)
      })
    },
    // 팀 필터 선택시 호출
    getSelectedTeamIndexEvent() {
      this.$event.$on(this.$eventList.selectedTeamIndex, selectedTeamIndex => {
        this.selectedTeamIndex = Number(selectedTeamIndex)
        this.$log.d('get selectedTeamIndex event :', selectedTeamIndex)
        if (this.markerState === null || this.kMarkers.length === 0) {
          return
        }

        // 기존에 선택된 마커 이미지 초기화
        if (this.selectedKMarker !== null) {
          const unselectedMarker = this.selectedKMarker
          this.drawUnselectedMarker(unselectedMarker)
          this.selectedKMarker = null
        }
        // 선택한 마커 클러스터 초기화
        if (this.selectedKMarkers !== null) {
          this.selectedKMarkers = null
        }

        let minLat = 1000
        let minLng = 1000
        let maxLat = 0
        let maxLng = 0

        // 클러스터링 초기화
        this.clusterer.clear()

        for (let i = 0; i < this.markerState.length; i++) {
          const numOfMarkers = Object.keys(this.markerState[i]).length
          for (let j = 0; j < numOfMarkers; j++) {
            if (this.selectedTeamIndex === -1 || this.selectedTeamIndex === i) {
              // 전체 || 선택된 팀
              this.kMarkers[i][j].setMap(this.map)
              this.clusterer.addMarker(this.kMarkers[i][j])
              let lat = Number(this.kMarkers[i][j].markerInfo.marker.y)
              let lng = Number(this.kMarkers[i][j].markerInfo.marker.x)
              if (minLat > lat) minLat = lat
              if (maxLat < lat) maxLat = lat
              if (minLng > lng) minLng = lng
              if (maxLng < lng) maxLng = lng
            } else {
              // 선택되지 못한 팀
              this.kMarkers[i][j].setMap(null)
            }
          }
        }

        // 현재 지도에 그려진 마커의 중앙으로 이동
        let centerLat = (maxLat + minLat) / 2
        let centerLng = (maxLng + minLng) / 2
        this.setKMarkerInTheMap(centerLat, centerLng, maxLat, maxLng, this.map.getLevel())
        // this.moveMapCenter(centerLat, centerLng)
      })
    },
    // 가장 멀리있는 마커가 맵에 표시되도록 맵 레벨 조정
    setKMarkerInTheMap(centerLat, centerLng, farthestLat, farthestLng, level) {
      setTimeout(() => {
        this.map.setLevel(level, {
          animate: false
        })
        this.map.setCenter(new kakao.maps.LatLng(centerLat, centerLng))
        let bounds = this.map.getBounds()
        let rect = []
        // bounds의 키가 바뀌어서 아래와 같이 처리
        for (let key in bounds) {
          // 함수도 같이들어가서 number만 입력받도록 처리
          if (typeof bounds[key] === 'number') {
            rect.push(bounds[key])
          }
        }
        rect.sort((a, b) => { return b - a }) // 내림차순 : [maxLng, minLng, maxLat, minLng]
        let maxLng = rect[0]
        let minLng = rect[1]
        let maxLat = rect[2]
        let minLat = rect[3]
        if (minLng <= farthestLng && farthestLng <= maxLng && minLat <= farthestLat && farthestLat <= maxLat) {
          // 지도상에 있는 경우
        } else if (level >= 10) {
          this.$log.d('infinit loop out', level)
        } else {
          this.setKMarkerInTheMap(centerLat, centerLng, farthestLat, farthestLng, level + 2)
        }
      }, 1000)
    },
    // 내 위치 마커 이미지 반환
    createMyLocationImage() {
      const imageSrc = this.markerImages.me
      const imageSize = new kakao.maps.Size(24, 24)
      const imageOption = { offset: new kakao.maps.Point(12, 12) }
      let markerImage = new kakao.maps.MarkerImage(imageSrc, imageSize, imageOption)
      return markerImage
    },
    // 기존에 선택했던 마커 이미지 초기화
    drawUnselectedMarker(unselectedMarker) {
      const teamIndex = unselectedMarker.teamIndex
      const markerIndex = unselectedMarker.markerIndex
      const marker = this.kMarkers[teamIndex][markerIndex]
      const markerImage = this.createMarkerImage(marker.isDone)
      marker.setZIndex(0)
      marker.setImage(markerImage)
    },
    // 선택된 마커 이미지 변경
    drawSelectedMarker(selectedKMarker) {
      const teamIndex = selectedKMarker.teamIndex
      const markerIndex = selectedKMarker.markerIndex
      const marker = this.kMarkers[teamIndex][markerIndex]
      const markerImage = this.createSelectedMarkerImage(marker.isDone)
      marker.setZIndex(1)
      marker.setImage(markerImage)
    },
    // 상태에 따른 마커 이미지 반환
    createMarkerImage(isDone) {
      const imageSrc = (isDone) ? this.markerImages.done : this.markerImages.yet
      const imageSize = new kakao.maps.Size(this.markerImageSize.width, this.markerImageSize.height)
      const imageOption = { offset: new kakao.maps.Point(this.markerImageSize.width / 2, this.markerImageSize.height) }
      let markerImage = new kakao.maps.MarkerImage(imageSrc, imageSize, imageOption)
      return markerImage
    },
    // 선택된 마커 이미지 반환
    createSelectedMarkerImage(isDone) {
      const imageSrc = (isDone) ? this.markerImages.done : this.markerImages.yet
      const imageSizeWidth = this.markerImageSize.width * this.selectScale
      const imageSizeHeight = this.markerImageSize.height * this.selectScale
      const imageSize = new kakao.maps.Size(imageSizeWidth, imageSizeHeight)
      const imageOption = { offset: new kakao.maps.Point(imageSizeWidth / 2, imageSizeHeight) }
      let markerImage = new kakao.maps.MarkerImage(imageSrc, imageSize, imageOption)
      return markerImage
    },
    // 좌표와 마커이미지를 받아 마커를 생성하여 리턴하는 함수
    createMarker(lat, lng, image) {
      const position = new kakao.maps.LatLng(lat, lng)
      const marker = new kakao.maps.Marker({
        position: position,
        image: image
      })

      return marker
    },
    moveMapCenter(lat, lng) {
      const moveLatLon = new kakao.maps.LatLng(lat, lng)
      this.map.panTo(moveLatLon)
    },
    setMapLevel(lat, lng, level) {
      const centerLatLon = new kakao.maps.LatLng(lat, lng)
      this.map.setLevel(1, { anchor: centerLatLon })
    }
  }
}

</script>
<style lang="scss" scoped>
#Map {
  .map {
    width: 100%;
    height: 100%;
  }

  .floating-ui {
    position: absolute;
    z-index: 1000;

    .el-button {
      width: 38px;
      padding: 0px;
      height: 38px;
    }
  }

  #cluster-info-wrapper {
    display: flex;
    flex-direction: column;
    max-height: 200px;
    overflow: auto;
    width: 100%;

    .cluster-markerinfo {
      min-height: 85px;
      cursor: pointer;
      display: flex;
      flex-direction: row;
      padding-top: 12px;
      padding-bottom: 12px;
      border-bottom: 1px solid var(--gray-color);
    }

    .cluster-markerinfo.no-phone {
      min-height: 70px;
    }
  }

  .map-button {
    right: 0px;
    margin: 8px;
    background-color: white;
    border-radius: 8px;
  }

  .single-marker {
    padding: 12px !important;
  }

  .selected-marker-info {
    display: flex;
    cursor: pointer;
    align-items: center;
    min-height: 85px;
    padding: 0 12px;
    border-radius: 8px;
    background-color: white;
    right: 0;
    bottom: 0;
  }

  .mobile.selected-marker-info {
    left: 0px;
    width: 90vw;
    margin: 16px auto;
  }

  .mobile {
    .selected-marker-title {
      font-weight: 550;
      font-size: 14px;
      margin-bottom: 8px;
    }

    .selected-marker-address {
      font-size: 13px;
      margin-bottom: 8px;
    }

    .selected-marker-phone {
      font-size: 15px;
    }
  }

  .web.selected-marker-info {
    margin: 16px;
    width: 300px;
  }

  .web {
    .selected-marker-title {
      font-weight: 550;
      font-size: 14px;
      margin-bottom: 8px;
    }

    .selected-marker-address {
      font-size: 13px;
      margin-bottom: 8px;
    }

    .selected-marker-phone {
      font-size: 15px;
    }
  }
}

/* Mobile */
@media only screen and (max-width : 768px) {
  #Map {
    #cluster-info-wrapper {
      max-height: 150px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Project/KakaoMap/index.vue